import { render, staticRenderFns } from "./counters.vue?vue&type=template&id=49530686&"
import script from "./counters.vue?vue&type=script&lang=js&"
export * from "./counters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49530686')) {
      api.createRecord('49530686', component.options)
    } else {
      api.reload('49530686', component.options)
    }
    module.hot.accept("./counters.vue?vue&type=template&id=49530686&", function () {
      api.rerender('49530686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/tracking/partials/counters.vue"
export default component.exports